import React, { useState } from "react";
import Flex from "../Flex";
import { DownArrow } from "../Icon/icons/DownArrow";
import * as SC from "./Accordion.styles";

interface AccordionProps {
  question: React.ReactNode;
  answer: React.ReactNode;
}

export const Accordion = ({ question, answer }: AccordionProps) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <SC.AccordionContainer open={open}>
      <SC.AccordionQuestion onClick={() => setOpen(!open)}>
        <span>{question}</span>
        <SC.AccordionButton open={open}>
          <Flex align="center" justify="center" width="100%" height="100%">
            <DownArrow />
          </Flex>
        </SC.AccordionButton>
      </SC.AccordionQuestion>
      {open && <label>{answer}</label>}
    </SC.AccordionContainer>
  );
};
